import { render, staticRenderFns } from "./ReclaimDetails.vue?vue&type=template&id=8ecf9536&"
import script from "./ReclaimDetails.vue?vue&type=script&lang=js&"
export * from "./ReclaimDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReclaimDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports